/* eslint-disable array-element-newline */
import {html, LitElement} from 'lit';
import {createRef, ref} from 'lit/directives/ref.js';
import styles from './slick-slider.component.scss?as=stylesheet';
import 'slick-carousel';
import {MutationController} from 'extensions/ui-controllers';

/**
 * @param {HTMLElement|HTMLSlotElement} element
 */
const flattenElement = element => {
	if (element.nodeName === 'SLOT') {
		return element?.assignedNodes({flatten: true});
	}

	return [element];
};

export default class SlickSlider extends LitElement {
	static styles = [styles];

	static get properties () {
		return {
			_defaultOptions: {
				attribute: false,
				state: true,
				type: Object
			},
			_firstLoaded: {
				attribute: false,
				state: true,
				type: Boolean
			},
			options: {
				type: Object
			}
		};
	}

	get mergedOptions () {
		return {
			...this._defaultOptions,
			...this.options
		};
	}

	get slides () {
		return Array
			.from(this.children)
			.reduce((children, child) => children.concat(flattenElement(child)), [])
			.filter(node => node.nodeName !== '#text' && node.nodeName !== '#comment');
	}

	sliderRef = createRef();

	constructor () {
		super();

		// Set private property values
		this._defaultOptions = {
			arrows: true,
			infinite: true,
			slidesToScroll: 1,
			slidesToShow: 1
		};

		// Set default property values
		this._firstLoaded = false;
		this.options = {};

		// Mutation observer
		this.mutationController = new MutationController(this, {
			attributes: false,
			childList: true,
			subtree: true
		});
	}

	connectedCallback () {
		super.connectedCallback();
	}

	async updateSlider () {
		await this.updateComplete;

		// Remove existing slick slider if it exists
		if (this._firstLoaded) {
			$(this.sliderRef.value).slick('unslick');
			this.sliderRef.value.innerHTML = '';
		}

		// Assign to dynamic slots
		for (let slide of this.slides) {
			const wrapper = document.createElement('div');
			const clone = slide.cloneNode(true);
			clone.originalElement = slide;
			wrapper.appendChild(clone);

			// Check if clone was clicked, and if so dispatch click event to the children of the original Element
			clone.addEventListener('click', () => {
				if (clone.originalElement) {
					for (const children of clone.originalElement.children) {
						children.dispatchEvent(new Event('click'));
					}
				}
			});

			this.sliderRef?.value?.appendChild(wrapper);
		}

		// Initialize slider if not loaded
		if (this.sliderRef?.value) {
			$(this.sliderRef.value).slick(this.mergedOptions);
			this._firstLoaded = true;
		}
	}

	updated () {
		this.updateSlider();
	}

	render () {
		return html`<div class="x-carousel-wrapper">
			<div class="x-carousel-layout" ${ref(this.sliderRef)}></div>
		</div>`;
	}
};
